import { useMemo } from "react"
import {
  Block,
  GasFee,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { selectWalletBalances, useDappSelector } from "#/redux-state"
import CurrencySymbol from "#/shared/components/CurrencySymbol"
import { GAS_BUFFER_FOR_BORROW_TRANSACTION } from "#/shared/hooks"
import { bigIntToHumanReadableFormat } from "#/shared/utils"

export default function BorrowGas() {
  const [css, theme] = useStyletron()

  const { mBTC } = useDappSelector(selectWalletBalances)

  const gasBufferAmount = useMemo(
    () =>
      bigIntToHumanReadableFormat(
        GAS_BUFFER_FOR_BORROW_TRANSACTION,
        Number(mBTC.decimals),
        Number(mBTC.decimals),
      ),
    [mBTC.decimals],
  )

  return (
    <Block
      className={css({
        display: "flex",
        alignItems: "center",
        gap: theme.sizing.scale100,
        padding: `${theme.sizing.scale500} ${theme.sizing.scale700}`,
        borderRadius: theme.borders.radius400,
        border: "1px solid",
        borderColor: theme.colors.borderOpaque,
        marginBottom: "auto",
      })}
    >
      <ParagraphSmall color={theme.colors.contentTertiary} marginRight="auto">
        Est. network fee
      </ParagraphSmall>
      <GasFee
        color={theme.colors.contentTertiary}
        size={14}
        overrides={{
          Svg: {
            style: {
              marginBottom: theme.sizing.scale0,
            },
          },
        }}
      />
      <ParagraphSmall color={theme.colors.contentTertiary}>
        {gasBufferAmount} <CurrencySymbol token="mBTC" />
      </ParagraphSmall>
    </Block>
  )
}
